import { render, staticRenderFns } from "./EducationalPointsApply.vue?vue&type=template&id=72bbca35&scoped=true&"
import script from "./EducationalPointsApply.vue?vue&type=script&lang=js&"
export * from "./EducationalPointsApply.vue?vue&type=script&lang=js&"
import style0 from "./EducationalPointsApply.vue?vue&type=style&index=0&id=72bbca35&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72bbca35",
  null
  
)

export default component.exports